/**
 * Parent class to work with focusable elements
 */
export default class Controls {

    constructor() {
        this._items = [];
        this._currentIndex = 0;
    }

    /**
     * Define here array of focusable elements
     */
    collectFocusable() {
        this._items = [];
    }

    /**
     * Activate group focusable elements, place focus on first one
     */
    focus() {
        if (this._items[this._currentIndex]) {
            this._items[this._currentIndex].unfocus();
        }
        this._currentIndex = -1;
        this.down();
    }

    /**
     * Deactivate - unfocus currenly focused in group
     */
    unfocus() {
        if (this._items[this._currentIndex]) {
            this._items[this._currentIndex].unfocus();
        }
    }

    /**
     * Process enter key
     */
    enter(itemsKey = '_items', indexKey = '_currentIndex') {
        if (this[itemsKey][this[indexKey]]) {
            this[itemsKey][this[indexKey]].enter();
        }
    }

    /**
     * Process ArrowRight
     */
    next() {}

    /**
     * Process ArrowLeft
     */
    prev() {}

    isPossibleUp() {
        return true;
    }

    isPossibleDown() {
        return true;
    }

    /**
     * Process ArrowUp
     */
    up(itemsKey = '_items', indexKey = '_currentIndex') {
        let prev = this[itemsKey].slice().reverse()
                       .findIndex((item, index) => index > this[itemsKey].length - 1 - this[indexKey] && item.isVisible());

        if (this[indexKey] >= 0 && prev === -1) {
            // Loop from end
            prev = this[itemsKey].slice().reverse()
                       .findIndex((item, index) => index >= 0 && item.isVisible());
        }
        if (prev >= 0) {
            if (this[itemsKey][this[indexKey]]) {
                this[itemsKey][this[indexKey]].unfocus();
            }
            this[indexKey] = this[itemsKey].length - 1 - prev;
            if (this[itemsKey][this[indexKey]]) {
                this[itemsKey][this[indexKey]].focus();
            }
        }
    }

    /**
     * Process ArrowDown
     */
    down(itemsKey = '_items', indexKey = '_currentIndex') {
        let next = this[itemsKey].findIndex((item, index) => index > this[indexKey] && item.isVisible());

        if (this[indexKey] > 0 && next === -1) {
            // Loop from start
            next = this[itemsKey].findIndex((item, index) => index >= 0 && item.isVisible());
        }
        if (next >= 0) {
            if (this[itemsKey][this[indexKey]]) {
                this[itemsKey][this[indexKey]].unfocus();
            }
            this[indexKey] = next;
            if (this[itemsKey][this[indexKey]]) {
                this[itemsKey][this[indexKey]].focus();
            }
        }
    }
}
